import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sr-only" }

import { OutboundLink as RawOutboundLink } from '@vuepress/client'
import { useThemeLocaleData } from '../../composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/**
 * Override the built-in `<OutboundLink>` for a11y
 */
const themeLocale = useThemeLocaleData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RawOutboundLink), null, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(themeLocale).openInNewWindow), 1)
    ]),
    _: 1
  }))
}
}

})